var _path, _path2, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayDebtFaster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7103 16.0485L62.7518 16.0485C63.5803 16.0485 64.2518 15.3769 64.2518 14.5485C64.2518 13.72 63.5803 13.0485 62.7518 13.0485H58.2103H53.6688C52.8404 13.0485 52.1688 13.72 52.1688 14.5485C52.1688 15.3769 52.8404 16.0485 53.6688 16.0485L56.7103 16.0485V19.09C56.7103 19.2223 56.7275 19.3506 56.7596 19.4728C42.2331 20.6779 30.8193 32.8498 30.8193 47.6874C30.8193 63.3241 43.4953 76.0001 59.132 76.0001C74.7686 76.0001 87.4446 63.3241 87.4446 47.6874C87.4446 32.2347 75.065 19.6733 59.6823 19.38C59.7007 19.2862 59.7103 19.1892 59.7103 19.09V16.0485ZM59.132 73.0001C73.1118 73.0001 84.4446 61.6672 84.4446 47.6874C84.4446 33.7077 73.1118 22.3748 59.132 22.3748C45.1522 22.3748 33.8193 33.7077 33.8193 47.6874C33.8193 61.6672 45.1522 73.0001 59.132 73.0001ZM84.2442 22.2448C82.1104 20.111 78.6509 20.111 76.5172 22.2448L84.2667 29.9492C86.3779 27.8137 86.3704 24.371 84.2442 22.2448ZM41.4164 22.2448C39.2826 20.111 35.8231 20.111 33.6894 22.2448C31.5631 24.371 31.5556 27.8137 33.6668 29.9492L41.4164 22.2448Z",
    fill: "#DED7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7611 32.9489C63.8734 32.7371 63.8197 32.4754 63.633 32.3251C63.4462 32.1748 63.1791 32.1782 62.9962 32.3331L51.0748 42.432C50.9697 42.521 50.906 42.6494 50.8987 42.787C50.8913 42.9245 50.9411 43.059 51.0362 43.1586L59.4572 51.9865L54.1355 61.9998C54.0212 62.2148 54.0784 62.4808 54.2709 62.6298C54.4634 62.7788 54.7353 62.7676 54.9148 62.6031L67.631 50.9505C67.7304 50.8595 67.7888 50.7323 67.793 50.5976C67.7972 50.463 67.747 50.3323 67.6535 50.2352L59.2345 41.4849L63.7611 32.9489Z",
    fill: "#B5058E",
    stroke: "#B5058E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.8892,
    y1: 41.4329,
    x2: 24.9198,
    y2: 41.4329,
    stroke: "#DED7FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.8892,
    y1: 61.8698,
    x2: 24.9198,
    y2: 61.8698,
    stroke: "#DED7FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 2.94141,
    y1: 51.6514,
    x2: 24.9197,
    y2: 51.6514,
    stroke: "#DED7FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayDebtFaster);
export default __webpack_public_path__ + "static/media/pay-debt-faster.2bc511e28622bf07559b2b4252a82a89.svg";
export { ForwardRef as ReactComponent };